import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter, useRoutes } from 'react-router-dom';

import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { Button } from '../../components';
import Loading from '../../components/Loading';
import { LoadingSize } from '../../components/Loading/consts/LoadingSize.enum';
import { router } from '../../routes';

function Routes() {
  return useRoutes(router.routes);
}

export default function RouterProvider() {
  const { reset } = useQueryErrorResetBoundary();

  return (
    <ErrorBoundary
      onReset={reset}
      fallbackRender={({ resetErrorBoundary }) => (
        <div>
          Router error <Button onClick={() => resetErrorBoundary()}>Try again</Button>
        </div>
      )}
    >
      <Suspense fallback={<Loading size={LoadingSize.M} />}>
        <BrowserRouter>
          <QueryParamProvider adapter={ReactRouter6Adapter} options={{ removeDefaultsFromUrl: true, updateType: 'replaceIn' }}>
            <Routes />
          </QueryParamProvider>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  );
}
